import { DateTime } from "luxon";

export const isToday = (timestamp: string) =>
  DateTime.fromISO(timestamp).toISODate() === DateTime.local().toISODate();
